export const label = 'Супроводжуючі документи';
export const maxLength = 200;
export const errors = {
  maxlength: `Максимальна довжина ${maxLength} символів`,
};
